// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { Colors } from '@tls/treact-ui';
import { InfoTag } from 'components/treactui-template/atoms/InfoTag';
import React from 'react';
import styled from 'styled-components';

interface TagContainerProps {
  tags?: string[];
  withoutLabel?: boolean;
  withoutHideOverflow?: boolean;
}

const TagContainer: React.FC<TagContainerProps> = ({ tags, withoutLabel, withoutHideOverflow }) => {
  if (!tags) {
    return <></>;
  }

  return (
    <Container>
      {!withoutLabel && <div>Tags:</div>}
      {!withoutHideOverflow && <HideOverflow />}
      {tags.map(tag => (
        <InfoTag key={tag}>
          <span className='font-size_xs font-weight_semibold'>{tag}</span>
        </InfoTag>
      ))}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  gap: 8px;
  margin-bottom: 0.5rem;
  flex-wrap: nowrap;
  overflow-x: hidden;
  align-items: center;
  width: 100%;
  height: 2.5rem;
`;

const HideOverflow = styled.div`
  background: linear-gradient(to right, rgba(${Colors.trwhite.rgb}, 0.02) 0, ${Colors.trwhite.hex} 100%);
  position: absolute;
  float: right;
  right: 0;
  height: 100%;
  width: 1rem;
`;

export default TagContainer;
